import { render, staticRenderFns } from "./ListGuest.vue?vue&type=template&id=0845462c&scoped=true&ref=lg"
import script from "./ListGuest.vue?vue&type=script&lang=js"
export * from "./ListGuest.vue?vue&type=script&lang=js"
import style0 from "./ListGuest.vue?vue&type=style&index=0&id=0845462c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845462c",
  null
  
)

export default component.exports